export default {
  data() {
    return {
      //items para paginação funcionar
      page:1,
      total_pages:0,
      total_items:0,
      in_page:0,
      query:""
    }
  },
  computed: {
    localStorageReference() {
      let result = null;
      switch(this.$route.name) {
        case "Edit-service":
          result = "form-create-service-list";
          break;
        case "Services-create":
          result = "form-create-service-list";
          break;
        case "Weight-in-create":
          result = "form-validate-service-list";
          break;
        case "Services-details":
          result = "service-details-animals-list";
          break;
        case "Milk-analysis":
          result = "form-milk-analysis";
          break;
        case "Animals-list":
          result = "list-animals";
          break;
      }
      return result;
    }
  },
  methods: {
    // só exibição: "2026-09-26 17:37:02 -0300" vira "26-09-2026 17:37" (outros formatos passam iguais)
    $_formatDateTime(value) {
      const m = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}:\d{2}):\d{2} [-+]\d{4}$/.exec(String(value));
      return m ? `${m[3]}-${m[2]}-${m[1]} ${m[4]}` : value;
    },
    $_parseDate(date) {
      let sliced = date.slice(0,10);
      const locale = 'pt-br';
      return new Date(sliced).toLocaleDateString(locale);
    },

    $_parseDateToDatePicker(date) {
      let sliced = date.slice(0,10);
      return sliced;
    },
    
    $_setAmount(data) {
      this.page = 1;
      this.amount = data;
      this.valuePerPage = data;
      this.in_page = data;
      const list = JSON.parse(localStorage.getItem(this.localStorageReference));
      this.allAnimals = list.filter((e, i) => i < data);
      this.total_pages = Math.ceil(list.length / data);
      this.tableKey = this.tableKey + 1;
    },
    $_returnServiceKind(kind) {
      if(kind === "weight") {
        return "Controle"
      } else {
        return "Supervisão"
      }
    },
    //infinite load depreciado (caso seja reativado deve colocar no box a classe css infinite-box para funcionar)
    /* $_loadMore({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.amount = this.amount + this.amount;
      }
    }, */
    parseDateToBrazilianModel(date) {
      if(date.toString().includes("-")) {
        const [year, month, day] = date.toString().split("-");
        if(year.length > 3) {
          return year + "-" + month + "-" + day;
        } else {
          return day + "-" + month + "-" + year;
        }
      } else {
        const [year, month, day] = date.toString().split("/");
        if(year.length > 3) {
          return year + "-" + month + "-" + day;
        } else {
          return day + "-" + month + "-" + year;
        }
      }
    },
    parseDate(date) {
      if(date) {
        if(date.toString().length < 2) {
          return undefined;
        }
        const [day,month,year] = date.split("-");
        return `${year}-${month}-${day}`;
      }
    }
  },
  watch:{
    page(val,oldVal) {
      //update no localstorage
      let list = JSON.parse(localStorage.getItem(this.localStorageReference));
      let newResults = [];
      if(list) {
        list.forEach(storageItem => {
          if(this.$route.name === "Weight-in-create") {
          this.allAnimals.forEach(animal => {
            if(storageItem.animal_id === animal.animal_id) {
              storageItem = animal;
            }
          })
        } else if(this.$route.name === "Animals-list") {
          this.computedAnimals.forEach(animal => {
            if(storageItem.id === animal.animal_id) {
              storageItem = animal;
            }
          })
        }
          else {
          this.computedAnimals.forEach(animal => {
            if(storageItem.animal_id === animal.animal_id) {
              storageItem = animal;
            }
          })
        }
          newResults.push(storageItem);
        });
        localStorage.setItem(this.localStorageReference, JSON.stringify(newResults));
        //reset de items para paginar
        this.allAnimals.splice(0, this.allAnimals.length);
        this.tableKey = this.tableKey + 1;
        let max = this.valuePerPage * parseFloat(val);
        let min = parseFloat(val) <= 2 ? this.valuePerPage : this.valuePerPage * parseFloat(val) - this.valuePerPage;
        this.in_page = max;
        //Comandos da paginação
        if(parseFloat(val) < parseFloat(oldVal)) {
          if(max === this.valuePerPage) {
            min = 0
          }
          if(this.localStorageReference === "list-animals") {
            this.allAnimals.push(...newResults.filter((e, i) =>  i < max  && i  >= min ));
          } else {
          this.allAnimals.push(...newResults.filter(e => (e.search_key || "").toLowerCase().includes(this.query) || (e.search_key || "").includes(this.query)).filter((e, i) =>  i < max  && i  >= min ));
          }
          this.tableKey = this.tableKey + 1; 
        } else {
          if(max === this.valuePerPage) {
            min = 0
          }
          if(this.localStorageReference === "list-animals") {
            this.allAnimals.push(...newResults.filter((e, i) =>  i < max  && i  >= min ));
          } else {
          this.allAnimals.push(...newResults.filter(e => (e.search_key || "").toLowerCase().includes(this.query) || (e.search_key || "").includes(this.query)).filter((e, i) =>  i < max  && i  >= min ));
          }
          this.tableKey = this.tableKey + 1;
        }
      }
    }
  }
}